
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/podcasts",
      function () {
        return require("private-next-pages/use-cases/podcasts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/podcasts"])
      });
    }
  